import { AssessmentSubmissionFormModel } from "app/features/assessments/providers/AssessmentFormProvider";
import {
  QuestionTypeEnum,
  FILE_TYPES,
} from "app/services/api/types/forms/enums/QuestionTypeEnum";
import { AssessmentModel } from "app/services/api/types/forms/models/AssessmentModel";
import { QuestionModel } from "app/services/api/types/forms/models/QuestionModel";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";

export const isQuestionOfTypeArray = (question: QuestionModel) =>
  question.type === QuestionTypeEnum.MULTI_SELECT ||
  question.type === QuestionTypeEnum.RADIO_BUTTONS;

export const isQuestionOfTypeFile = ({ type }: { type: QuestionTypeEnum }) =>
  FILE_TYPES.includes(type) || type === QuestionTypeEnum.ELECTRONIC_SIGNATURE;

export function useAssessmentDefaultValues() {
  const generateDefaultValues = (
    assessment: AssessmentModel,
    entryData?: SubmittedFormModel,
  ): AssessmentSubmissionFormModel => {
    const differentForms = assessment.id !== entryData?.form.id;

    const getAnswer = (question: QuestionModel) => {
      for (const section of entryData?.sections ?? []) {
        const entryQuestion = section.questions.find(
          (entryQuestion) =>
            entryQuestion.id === question.id ||
            (differentForms &&
              question.id &&
              entryQuestion.id < question.id &&
              entryQuestion.content === question.content),
        );
        if (entryQuestion) {
          return entryQuestion;
        }
      }
    };

    return assessment.sections.reduce((previous, current) => {
      current.questions.forEach((question) => {
        if (question.id) {
          const submittedQuestion = getAnswer(question);

          let value: string | string[] = submittedQuestion?.answer?.value || [];
          if (!isQuestionOfTypeArray(question)) {
            value = submittedQuestion?.answer?.value[0] || "";
          }
          previous[question.id] = {
            value,
            free_text: submittedQuestion?.answer?.free_text || "",
            files:
              submittedQuestion?.answer?.media ||
              (isQuestionOfTypeFile(question) ? [] : undefined),
            question_type: question.type,
          };
        }
      });

      return previous;
    }, {});
  };

  return {
    generateDefaultValues,
  };
}
